(function (scope) {
  'use strict';

	var App = function () {
		this.features = {

			common: {
				init: function () {
					this.mobileTest = /Android|iPhone|iPad|iPod|IEMobile|Opera Mini|webOS/i;
					this.isMobile = this.mobileTest.test(navigator.userAgent);

					this.lang = window.location.href.indexOf('/ru/') > -1 ? 'ru' : 'lv';

					var nometnesPopUp = $('.js-popup_nometnes');
					if (nometnesPopUp.length && this.lang !== 'ru') {
						this.nometnesPopUp = new window.Roots.PopUp(nometnesPopUp, this.isMobile);
						this.nometnesPopUp.open(500);
					}

					var $cover = $('.js-mobile-height-fixed');
					if ($cover.length && this.isMobile) {
						$cover.height($cover.height());
						$cover.css('padding-top', 0);
					}

					var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
					if (!this.isMobile && width > 1080) {
						this.skrollr = skrollr.init();
						$('body').addClass('skrollr-enabled');
					}

          // Formas
          var $nodarbibuFormas = (this.lang === 'lv') ? $('#nf-form-1-cont') : $('#nf-form-5-cont');
          if ($nodarbibuFormas.length) {
            this.nodarbibuFormas = new window.Roots.Forms($nodarbibuFormas);
          }

          var $nometnuFormas = (this.lang === 'lv') ? $('#nf-form-9-cont') : $('#nf-form-10-cont');
          if ($nometnuFormas.length) {
            this.nometnuFormas = new window.Roots.Forms($nometnuFormas, {
              replaceListOptions: true
            });
          }

          // Galerija
          var galerija = $('.js-gallery');
          if (galerija.length) {
            this.galerija = new window.Roots.Gallery(galerija);
          }

          // Mobilā navigācija
          var $header = $('header.page-header');
          var $hamburger = $header.find('.js-nav-open');
          if ($hamburger.length) {
            $hamburger.on('click touchdown', function(event) {
              $header.toggleClass('nav-open');
            });
          }
          var $close = $header.find('.js-nav-close');
          if ($close.length) {
            $close.on('click touchdown', function (event) {
              $header.toggleClass('nav-open');
            });
          }

          // Cookie paziņojums
          var $cookieAlert = $('.js-cookie-alert');
          if ($cookieAlert.length) {
            this.cookieAlert = new window.Roots.CookieAlert($cookieAlert);
          }
				}
			},

			lity_lightbox: {
				init: function () {
					this.lityLightbox = new window.Roots.LityLightbox('.js-lity-lightbox');
				}
			},

			anchor_animate: {
				init: function () {
					this.anchorAnimate = new window.Roots.AnchorAnimate('.js-anchor-animate');
				}
			}
		};
	};

	App.prototype.init = function () {
    new window.Roots.Copyright({
			project: 'RoboHub',
			year: '2016-09',
			colors: [
				'#872b90',
				'#c9187e'
			],
      people: [
        {name: "Raimonds Sarkanbārdis"}
      ],
      list: false
		});

		this.features.common.init();
		this.initFeatures();
	};

	App.prototype.initFeatures = function () {
		var body = document.querySelector('body');
		var features = body.getAttribute('data-features');

		if (features) {
			var featuresArray = features.split(' ');
			featuresArray.forEach(this.processFeature, this);
		}
	};

	App.prototype.processFeature = function (value, index, array) {
		var feature = this.features[value];
		if (feature && typeof feature.init === 'function') {
			feature.init.call(this);
		}
	};

	scope.App = App;
})(window.Roots || (window.Roots = {}));
